import { ReactElement, useEffect } from "react";
import { BottomNavLayout } from "../components/templates/BottomNavLayout";
import { ResultBody } from "../components/atoms/ResultAnalysis/ResultBody";
import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
dayjs.extend(isSameOrBefore);
import { useAtom } from "jotai";
import { footerIndexAtom } from "../store";
import { useModifiedTranslation } from "../hooks/useModifiedTranslation";
import { BasicPageLayout } from "../components/templates/BasicPageLayout";

/*
 * ログイン後 解析結果グラフ画面
 */
export function AnalysisResult(): ReactElement {
  const t = useModifiedTranslation();

  const [, setFooterIndex] = useAtom(footerIndexAtom);

  useEffect(() => {
    setFooterIndex(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BottomNavLayout>
      <BasicPageLayout
        title={t("Graph.common.analysisResult")}
        maxW="container.md"
        flex={1}
      >
        <ResultBody />
      </BasicPageLayout>
    </BottomNavLayout>
  );
}
